/**
 * Zeit- und Wertformate des Verlaufs. Zeitpunkte stehen in der Zeit des Objekts, Aufenthaltstage
 * sind Kalendertage und werden zeitzonensicher gelesen – nie als ISO-Text.
 */
const WEEKDAY = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

/** „19.10. 20:31“ in Objektzeit; ein anderes Jahr als heute mit Jahr. */
export function historyDateTime(value: string | null, timeZone: string, now = new Date()) {
  if (!value) return '—';
  const date = new Date(value);
  // Unlesbar ist nicht „nicht gesetzt“ – der Rohwert bleibt sichtbar.
  if (Number.isNaN(date.getTime())) return value;
  const year = (at: Date) =>
    new Intl.DateTimeFormat('de-DE', { year: 'numeric', timeZone }).format(at);
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    ...(year(date) === year(now) ? {} : { year: 'numeric' }),
    hour: '2-digit',
    minute: '2-digit',
    timeZone,
  })
    .format(date)
    .replace(',', '');
}

const day = (iso: string) => new Date(`${iso.slice(0, 10)}T00:00:00Z`);

/** „Fr 30.10.“; ein anderes Jahr als heute mit Jahr („Fr 30.10.2027“). */
export function historyDay(iso: string, now = new Date()) {
  const date = day(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return `${WEEKDAY[date.getUTCDay()]} ${historyShortDate(iso, now)}`;
}

/** „30.10.“, in einem anderen Jahr „30.10.2027“. */
export function historyShortDate(iso: string, now = new Date()) {
  const date = day(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const year = date.getUTCFullYear() === now.getFullYear() ? '' : String(date.getUTCFullYear());
  return `${String(date.getUTCDate()).padStart(2, '0')}.${String(date.getUTCMonth() + 1).padStart(2, '0')}.${year}`;
}

/** „30.10. – 31.10.“, ein Tag ohne Strich. */
export function historyStayRange(from: string, to: string, now = new Date()) {
  return from === to
    ? historyShortDate(from, now)
    : `${historyShortDate(from, now)} – ${historyShortDate(to, now)}`;
}

export function historyMoney(value: number | null, currency: string | null | undefined) {
  if (value === null) return '—';
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currency || 'EUR',
    // Glatte Beträge ohne „,00“ wie im Board („118 €“), sonst auf den Cent.
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/** „110,00 € → 118,00 €“; ohne Ziel nur der bestätigte Wert. */
export function historyChange(
  confirmed: number | null,
  desired: number | null,
  format: (value: number | null) => string,
) {
  if (desired === null || desired === confirmed) return format(confirmed);
  return `${format(confirmed)} → ${format(desired)}`;
}
